import { connect } from "react-redux";
import { form } from "MODULES/shared/components/Forms";
import { formValueSelector } from "redux-form";
import { validator } from "LIB/validate-this";
import * as rules from "LIB/validation/rules";
import withRma from "MODULES/RMAsAndWarranties/decorators/withRma";
import * as actions from "MODULES/RMAsAndWarranties/actions";
import Form from "./Form";

const selector = formValueSelector("rmaCustomerDetails");

function validate(values) {
  return validator(values, f => {
    if (values.reason === "other") {
      f.validate("other_reason").satisfies(rules.required);
    }
  });
}

export default withRma(
  connect(
    state => ({
      customerRmaReasons: selector(state, "reason")
    }),
    dispatch => ({
      onSubmit: data => dispatch(actions.update(data))
    })
  )(
    form({
      form: "rmaCustomerDetails",
      validate
    })(Form)
  )
);



// WEBPACK FOOTER //
// ./app/modules/RMAsAndWarranties/components/Detail/Panel/Details/EditCustomerDetails.jsx